// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"624":"public","792":"main"}[chunkId] + "-legacy." + {"624":"f01b8bd1","792":"8dee7342"}[chunkId] + ".js";
};